import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dmaList: [],
  productTypes: [],
  priceRange: ["", ""],
  selectedDateRange: { from: null, to: null },
  selectedSize: [],
  filterChecks: {},
  selectedSizes: [], // Added for global selectedSizes
  inComeSliderValue: ["", ""], // Added for global income slider
  filters: {}, // Added for global filters object
  items: [], // Added for global items array
  pageNum: 1,
  viewType: "kanban",
  chatViewState: "float",
};

const filterSlice = createSlice({
  name: "filters",
  initialState,
  searchText: "", // Added for global search
  showNearby: false,
  reducers: {
    setDmaList: (state, action) => {
      state.dmaList = action.payload;
    },
    setProductTypes: (state, action) => {
      state.productTypes = action.payload;
    },
    setPriceRange: (state, action) => {
      state.priceRange = action.payload;
    },
    setDateRange: (state, action) => {
      state.selectedDateRange = action.payload;
    },
    setSelectedSize: (state, action) => {
      state.selectedSize = action.payload;
    },
    setFilterChecks: (state, action) => {
      state.filterChecks = action.payload;
    },
    setSearchText: (state, action) => {
      state.searchText = action.payload;
    },
    setSelectedSizes: (state, action) => {
      state.selectedSizes = action.payload;
    },
    setInComeSliderValue: (state, action) => {
      state.inComeSliderValue = action.payload;
    },
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
    setItems: (state, action) => {
      state.items = action.payload;
    },
    setMapView: (state, action) => {
      state.mapView = action.payload;
    },
    setShowNearby: (state, action) => {
      state.showNearby = action.payload;
    },
    setPagination: (state, action) => {
      state.pageNum = action.payload;
    },
    clearAllFilters: (state) => {
      Object.assign(state, initialState);
      state.searchText = "";
    },
    // Map Slice
    setSelectedState: (state, action) => {
      state.selectedState = action.payload;
    },
    clearSelectedState: (state) => {
      state.selectedState = null;
    },
    setSelectedStateId: (state, action) => {
      state.selectedStateId = action.payload;
    },
    clearSelectedStateId: (state) => {
      state.selectedStateId = null;
    },
    setMapCamera: (state, action) => {
      state.mapCamera = action.payload;
    },
    clearMapCamera: (state) => {
      state.mapCamera = null;
    },
    setUserInteracted: (state, action) => {
      state.userInteracted = action.payload;
    },
    clearUserInteracted: (state) => {
      state.userInteracted = null;
    },
    setCurrentMapZoom: (state, action) => {
      state.currentMapZoom = action.payload;
    },
    resetCurrentMapZoom: (state) => {
      state.currentMapZoom = null;
    },
    setFiltersApplied: (state, action) => {
      state.filterApplied = action.payload;
    },
    clearAllFiltersApllied: (state) => {
      state.filterApplied = null;
    },
    setShapeOfMap: (state, action) => {
      state.shapeOfMap = action.payload;
    },
    setZoom: (state, action) => {
      state.zoomOnMap = action.payload;
    },
    // Griview or List View State
    setViewType: (state, action) => {
      state.viewType = action.payload;
    },
    setChatViewState: (state, action) => {
      state.chatViewState = action.payload;
    },
  },
});

export const {
  setDmaList,
  setProductTypes,
  setPriceRange,
  setDateRange,
  setSelectedSize,
  setFilterChecks,
  setSearchText,
  setSelectedSizes,
  setInComeSliderValue,
  setFilters,
  setItems,
  setMapView,
  setShowNearby,
  clearAllFilters,
  setPagination,
  //Map Slice
  setSelectedState,
  clearSelectedState,
  setUserInteracted,
  clearUserInteracted,
  setCurrentMapZoom,
  currentMapZoom,
  setMapCamera,
  resetCurrentMapZoom,
  clearMapCamera,
  setSelectedStateId,
  clearSelectedStateId,
  setFiltersApplied,
  clearAllFiltersApllied,
  setShapeOfMap,
  setZoom,
  setViewType,
  setChatViewState,
} = filterSlice.actions;

export default filterSlice.reducer;
